export const COOKIE_NAME = 'searchFullCPG';

export const FREESHIPPING_SNACKBAR_DURATION = {
  SHORT: 'SHORT',
  NORMAL: 'NORMAL',
  LONG: 'LONG',
  INFINITE: 'INFINITE',
};
